import { ExportButton } from '@/common/buttons/ExportButton';
import { Grid } from '@/common/grid/Grid';
import { useModuleFromRoute } from '@/common/hooks/route/useModuleFromRoute';
import { useNavState } from '@/common/navState/NavStateContext';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { Title } from '@/common/title/Title';
import { DateUtils } from '@/common/utils/DateUtils';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { Box } from '@mui/material';
import { useEffect, useRef, useState } from 'react';

export const ReallocTrxViewer = () => {

  const { navState } = useNavState();
  const rsrc = useRsrc();
  const module = useModuleFromRoute();

  const [title, setTitle] = useState();
  const gridRef = useRef();

  const [fieldDefs, setFieldDefs] = useState();
  const [exportReq, setExportReq] = useState();

  useEffect(() => {
    const viewerReqParam = navState.viewerReqParam;
    rsrc.viewerFieldDefs(module, 'REALLOC_CALC_TRX_VIEWER_PLUGIN', viewerReqParam, navState.entity).then(fieldDefs => {
      setFieldDefs(fieldDefs);
    });

    setTitle('Transactions');
  }, [])

  const onGridReady = (params) => {
    const dataSource = {
      getRows: (params) => {

        const expr = ExprUtils.filterModelToExpr(params.filterModel, fieldDefs);

        const reqParam = {
          ...navState.viewerReqParam,
          startRow: params.startRow,
          endRow: params.endRow,
          expr
        };
                
        const plugin = 'REALLOC_CALC_TRX_VIEWER_PLUGIN';
        buildAndSetExportReq(reqParam, plugin);

        rsrc.viewerRows(module, 'REALLOC_CALC_TRX_VIEWER_PLUGIN', reqParam, navState.entity).then(res => {
          gridRef.current.onGridSuccess(res, params);
          gridRef.current.resize();
        })

        rsrc.viewerCount(module, 'REALLOC_CALC_TRX_VIEWER_PLUGIN', reqParam, navState.entity).then(count => {
          gridRef.current.setCount(count);
        })

        // rsrc.viewerAggTotals(module, 'REALLOC_CALC_TRX_VIEWER_PLUGIN', reqParam, navState.entity).then(aggTotals => {
        //   gridRef.current.setTotalsRow(aggTotals);
        // })
      }
    }

    gridRef.current.setDataSource(dataSource);
  }

  const buildAndSetExportReq = (reqParam, plugin) => {
    const exportReq = {
      timeZoneName: DateUtils.timeZoneName(),
      name: navState.title + ' Export',
      module,
      entity: 'REALLOC_RATIO',
      uiType: 'VIEWER',
      viewerPluginCode: 'REALLOC_CALC_TRX_VIEWER_PLUGIN',
      viewerReqParam: reqParam,
      fieldDefs,
    };

    setExportReq(exportReq);
  }
  
  return (
    fieldDefs &&
    <>
      <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Title icon={fas.faListUl} title={title} />
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <ExportButton exportReq={exportReq} />
        </Box>
      </Box>
      <Grid
        key={'realloc'}
        ref={gridRef}
        gridOptions={{ fieldDefs }}
        events={{ onGridReady }}
      />
    </>
  );
}